import React from 'react'
import moment from 'moment'
import { homeActions } from '../../actions/home.actions'
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit'
import classNames from 'classnames'
import DockPadChip from '../../components/DockPadChips'
import { scheduleActions } from '../../actions/schedule.actions'


const tasksObjectToArray = tasksObject => {
  const a = []
  if (!tasksObject) {
    return a
  }
  Object.entries(tasksObject).forEach(([key, value]) => {
    value['uid'] = key
    a.push(value)
  })
  return a
}

const usersObjectToMap = usersObject => {
  const a = {}
  if (!usersObject) {
    return a
  }
  Object.entries(usersObject).forEach(([key, value]) => {
    let userName = new Array(value['first_name'], value['last_name'])
    let userEmail = new Array(value.email)
    let responsible = userName.join(' ') + ` - ${userEmail.join('')}`
    a[key] = responsible
  })
  return a
}

const renderProgressBar = (progress, classes) => {
  return (
    <div className='progress-bar-empty'>
      
    </div>
  )
}

const renderStatus = status => {
  return <DockPadChip variant={LookAheadVariant[status]} label={status} />
}

export const LookAheadStatuses = {
  OPEN: 'Open',
  COMMITTED: 'Committed',
  COMPLETE: 'Complete',
  INCOMPLETE: 'Incomplete'
}

export const LookAheadVariant = {
  Open: 'yellow',
  Committed: 'blue',
  Complete: 'green',
  Incomplete: 'red'
}

const customTasksArray = (tasksArray, usersMap, dispatch, classes) => {
  return tasksArray.map(element => {
    const task = {}
    task.code = element.code
    task.name = element.name
    task.progressInt = element.progress
    task.progress = renderProgressBar(element.progress, classes)
    task['start-date'] = moment(element.timeSpan['start_time']).format(
      'YYYY-MM-DD'
    )
    task['end-date'] = moment(element.timeSpan['end_time']).format('YYYY-MM-DD')
    task.startMs = element.timeSpan["start_time"]
    task.endMs = element.timeSpan["end_time"]
    const assignees = !!element.assignees ? element.assignees : {}


    const responsible = Object.entries(usersMap)
      .filter(([key, value]) => {
        return key in assignees
      })
      .map(([, value]) => value)
      .join(',\n ')

    task.responsible = responsible
    const status = !!element.status ? element.status : LookAheadStatuses.OPEN
    task.status = renderStatus(status)
    task.lookAheadStatus = status
    if(element.code === 'Schedule') {
      task.edit = (
        <IconButton
          onClick={() => {
            dispatch(scheduleActions.openScheduleDrawer(element.uid, element.name))
          }}>
          <EditIcon
            className={classNames(classes.AllTasksScreenVisibilityIcon)}
          />
        </IconButton>
      )
    } else {
      task.edit = (
        <IconButton
          onClick={() => {
            dispatch(homeActions.openEditBoard(element.uid, 'tasks'))
          }}>
          <EditIcon
            className={classNames(classes.AllTasksScreenVisibilityIcon)}
          />
        </IconButton>
      )
    }

    task.uid = element.uid

    return task
  })
}

export const AllTasksScreenHelpers = {
  tasksObjectToArray,
  usersObjectToMap,
  customTasksArray
}



// WEBPACK FOOTER //
// ./src/containers/helpers/AllTasksScreen.tsx